'use client';
import { useEffect } from "react";
import { authStore } from "store/authStore";

const AuthCheck = () => {
  useEffect(() => {
    if (!authStore.isSignIn) {
      window.location.href = '/login';
    };
  }, []);
  return null
}


export default AuthCheck